const initialState = {
    jobs: [],
    open: true,
    visible: false,
    modalJobId: null,
    userPreference: {
        openInBrowserWhenReady: false,
    },
}

const updateJob = (job, payload) => {
    if (job.id !== payload.id) return job
    return {
        ...job,
        ...payload,
        items: payload.items || job.items,
    }
}

const updateJobItem = (job, payload) => {
    if (job.id !== payload.jobId) return job
    const { jobId, itemId, ...itemPayload } = payload
    return {
        ...job,
        items: job.items.map((item) =>
            item.id === itemId
                ? {
                      ...item,
                      ...itemPayload,
                  }
                : item
        ),
    }
}

const documentJobsReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'ADD_DOCUMENT_JOB':
            return {
                ...state,
                visible: true,
                open: true,
                jobs: [action.payload, ...state.jobs],
            }
        case 'UPDATE_DOCUMENT_JOB':
            return {
                ...state,
                jobs: state.jobs.map((job) => updateJob(job, action.payload)),
            }
        case 'UPDATE_DOCUMENT_JOB_ITEM':
            return {
                ...state,
                jobs: state.jobs.map((job) => updateJobItem(job, action.payload)),
            }
        case 'REMOVE_DOCUMENT_JOB': {
            const jobs = state.jobs.filter((job) => job.id !== action.payload)
            return {
                ...state,
                visible: jobs.length > 0,
                jobs: jobs,
            }
        }
        case 'CLEAR_FINISHED_DOCUMENT_JOBS': {
            const jobs = state.jobs.filter((job) => job.status === 'running')
            return {
                ...state,
                visible: jobs.length > 0,
                jobs: jobs,
            }
        }
        case 'SET_DOCUMENT_JOBS_TRAY_OPEN':
            return {
                ...state,
                open: action.payload,
            }
        case 'SET_DOCUMENT_JOBS_MODAL_JOB':
            return {
                ...state,
                modalJobId: action.payload,
            }
        case 'SET_DOCUMENT_JOBS_USER_PREFERENCE':
            return {
                ...state,
                userPreference: {
                    ...state.userPreference,
                    ...action.payload,
                },
            }
        default:
            return state
    }
}

export default documentJobsReducer
